import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BlogCard, { articleShape } from "./BlogCard";
import "./RelatedArticles.css";

export default function RelatedArticles({ articles }) {
  const { t } = useTranslation("blog");
  if (!articles?.length) return null;

  return (
    <section className="related-articles" aria-labelledby="related-heading">
      <div className="section-eyebrow" aria-hidden="true">
        <span className="eyebrow-line" />
        <span>{t("related.eyebrow")}</span>
      </div>
      <h2 id="related-heading" className="related-title">
        {t("related.title0")} <em>{t("related.title1")}</em>
      </h2>
      <div className="related-grid">
        {articles.map((a) => (
          <BlogCard key={a.slug} article={a} />
        ))}
      </div>
    </section>
  );
}

RelatedArticles.propTypes = {
  articles: PropTypes.arrayOf(articleShape).isRequired,
};
